<template>
  <div>
    <ClientConclusionDiagnosisForm
        v-if="(userCanAdd || userCanEdit) && showForm"
        :establishment="establishment"
        :diagnoses="diagnoses"
        v-on:submit="submitForm"
        v-on:cancel="closeForm"/>

    <div class="mb-5">
      <div class="py-3 px-4 border bg-light font-weight-bold text-primary position-relative">
        Диагнозы

        <div
          v-if="userCanAdd"
          class="position-absolute"
          style="right:10px;top:8px;">
          <button
            class="btn btn-primary"
            @click="showForm = true">
            Новый диагноз
          </button>
        </div>
      </div>

      <ClientConclusionDiagnosisList
          v-on:select="selectEstablishment"
          :items="current" />

      <div
          @click="showPast =! showPast"
          class="py-3 px-4 border-left border-right border-bottom bg-light font-weight-bold text-primary cursor-pointer">
        <u>История диагнозов</u>
      </div>

      <ClientConclusionDiagnosisList
          v-on:select="selectEstablishment"
          v-if="showPast"
          :items="past" />
    </div>
  </div>
</template>

<script>
import ClientConclusionDiagnosisList from './diagnosis/List';
import ClientConclusionDiagnosisForm from './diagnosis/Form';
import formatDate from '../../../utils/formatDate';

export default {
  name: 'ClientConclusionDiagnoses',

  components: {ClientConclusionDiagnosisList, ClientConclusionDiagnosisForm},

  props: ['diagnoses', 'establishments', 'submitDiagnosisEstablishment', 'userCanAdd', 'userCanEdit'],

  data() {
    return {
      showPast: false,
      establishmentId: null,
      showForm: false,
      types: {
        basic: 'основной диагноз',
        complication: 'осложнения основного',
        concomitant: 'сопутствующий',
        unspecified: 'предварительный диагноз ',
      },
    };
  },

  computed: {
    data() {
      const data = this.establishments.map(e => {
        const {id, note, dateFrom, dateTo, createdBy, type} = e;
        const diagnosis = this.diagnoses.find(f => f.id === e.diagnosis);
        const typeTitle = typeof this.types[type] !== 'undefined' ? this.types[type] : '-';

        return { id, dateFrom, dateTo, note, diagnosis, createdBy, typeTitle };
      });

      data.sort((a, b) => b.dateFrom.getTime() - a.dateFrom.getTime());

      return data;
    },

    past() {
      return this.data.filter(i => i.dateTo instanceof Date);
    },

    current() {
      return this.data.filter(i => !(i.dateTo instanceof Date));
    },

    establishment() {
      return this.establishments.find(i => i.id === this.establishmentId);
    },
  },

  methods: {
    selectEstablishment(id) {
      if (!this.userCanEdit) {
        return false;
      }

      this.showForm = true;
      this.establishmentId = id;
    },

    closeForm() {
      this.showForm = false;
      this.establishmentId = null;
    },

    formatDate(date, format) {
      return formatDate(date, format);
    },

    async submitForm(data) {
      await this.submitDiagnosisEstablishment(data);

      this.closeForm();
    },
  },
};
</script>
